export default __webpack_public_path__ + "static/media/_Official Bio_.fa0763a5.jpeg";